import { DefaultTheme } from "styled-components";

export enum VisualIdentityTypes {
	GET_VISUAL_IDENTITY = "@visualIdentity/GET_VISUAL_IDENTITY",
	SAVE_VISUAL_IDENTITY = "@visualIdentity/SAVE_VISUAL_IDENTITY",
	UPDATE_COLORS = "@visualIdentity/UPDATE_COLORS",
	UPDATE_LOGO_URL = "@visualIdentity/UPDATE_LOGO_URL",
	SET_VISUAL_IDENTITY = "@visualIdentity/SET_VISUAL_IDENTITY",
	RESET_COLORS = "@visualIdentity/RESET_COLORS",
	RESET_REDUCER_VISUAL_IDENTITY = "@visualIdentity/RESET_REDUCER_VISUAL_IDENTITY",
}

export interface VisualIdentity {
	primaryColor?: string;
	headerColor?: string;
	logoUrl?: string;
}

export interface VisualIdentityState {
	readonly visualIdentity: {
		colors: DefaultTheme;
		logoUrl?: string;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetVisualIdentity {
	type: typeof VisualIdentityTypes.GET_VISUAL_IDENTITY;
}

export interface SaveVisualIdentity {
	type: typeof VisualIdentityTypes.SAVE_VISUAL_IDENTITY;
	payload: {
		colors: DefaultTheme | null;
		logoUrl?: string;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface UpdateColors {
	type: typeof VisualIdentityTypes.UPDATE_COLORS;
	payload: {
		colors: DefaultTheme;
	};
}

export interface UpdateLogoUrl {
	type: typeof VisualIdentityTypes.UPDATE_LOGO_URL;
	payload: {
		logoUrl?: string;
	};
}

export interface SetVisualIdentity {
	type: typeof VisualIdentityTypes.SET_VISUAL_IDENTITY;
	payload: VisualIdentity;
}

export interface ResetColors {
	type: typeof VisualIdentityTypes.RESET_COLORS;
}

export interface ResetReducerVisualIdentity {
	type: typeof VisualIdentityTypes.RESET_REDUCER_VISUAL_IDENTITY;
}

export type VisualIdentityActionTypes =
	| GetVisualIdentity
	| SaveVisualIdentity
	| UpdateColors
	| UpdateLogoUrl
	| SetVisualIdentity
	| ResetColors
	| ResetReducerVisualIdentity;
